export const BY_DECISION = 'decision';
export const BY_TYPE = 'type';

export const BY_DECISION_TAB_VALUE = '1';
export const BY_TYPE_TAB_VALUE = '2';

export const PENDING = 'Pending';
export const DONE = 'Done';
export const TOTAL = 'Total';
export const CONSULTED = 'Consulted';
export const PROGRESS = 'Progress';

export const LABELSTATUS = {
  APPROVED: 'Approved',
  DONE: 'Done',
  MANAGER_CONFIRMED: 'Manager Confirmed',
  MANAGER_NOT_CONFIRMED: 'Not Confirmed By Manager',
  REVOKED: 'Revoked',
  CONSULT: 'Consult',
  CONDITIONALLY_CERTIFIED: 'Conditionally Certified',
  REJECTED: 'Rejected',
  PENDING: 'Pending',
  END_DATE_CHANGED: 'End Date Changed',
  NO_ACTION_REQUIRED: 'NoActionRequired',
  TERMINATED: 'Terminated',
  REASSIGN: 'Reassign',
  ROLE: 'Role',
  USER: 'User',
  ENTITLEMENT: 'Entitlement',
  PARENT_ENTITLEMENT: 'ParentEnt',
  CHILD_ENTITLEMENT: 'ChildEntitlement',
  ACCOUNT: 'Account',
  DECOMMISSIONED: 'Decommissioned',
  DOES_NOT_BELONG_TO_ME: 'Does Not Belong',
};
